import React, { Component } from "react";
import { connect } from 'react-redux';
import { Modal } from "react-bootstrap";
import helpmindlogo from "../header/assets/helpmindlogo.png";
import Login from "./views/Login";
import Register from "./views/Register";
import "./assets/authModal.scss";

const mapStateToProps = (state) => {
  return {
    showLoginPanel: state.root.showLoginPanel,
    loginTabActive: state.root.loginTabActive
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoginPanel: () => {
      dispatch({ type: 'HIDE_LOGIN_PANEL' });
    },
    toggleActiveTab: (active) => {
      dispatch({ type: 'TOGGLE_LOGIN_TAB', active: active })
    }
  }
}

class AuthModal extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      showLoginPanel: this.props.showLoginPanel,
      loginTabActive: this.props.loginTabActive
    };
  }

  render() {
    console.log(this.state.loginTabActive, this.props.loginTabActive);
    const { showLoginPanel, toggleLoginPanel, toggleActiveTab, loginTabActive, ...rest } = this.props;
    // hide loginPanel if it's not set..
    if (!showLoginPanel) {
      return null;
    }

    return (
      <div className="Login">

        <Modal
          {...rest}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          show={showLoginPanel}
          onHide={toggleLoginPanel}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              <img className="logo" src={helpmindlogo} alt="help my mind" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="tabs">
              <div className={`col-sm-6 ${loginTabActive ? 'active' : ''}`}>
                <a href="#" onClick={() => toggleActiveTab(loginTabActive)}>Login</a>
              </div>
              <div className={`col-sm-6 ${!loginTabActive ? 'active' : ''}`}>
                <a href="#" onClick={() => toggleActiveTab(loginTabActive)}>Register</a>
              </div>
            </div>
            {loginTabActive &&
              <div>
                <Login />
              </div>
            }
            {!loginTabActive &&
              <div>
                <Register />
              </div>
            }
          </Modal.Body>
        </Modal>

      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal);



// WEBPACK FOOTER //
// ./src/containers/auth/AuthModal.js